import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.refactoring');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-refactoring',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.refactoring/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

/* ═══════════════════════════════════════════
   Apple / Toss Inspired Design System
   ═══════════════════════════════════════════ */
/* ── Design Tokens ── */
/* ── Page Shell ── */
.refactor-page {
  min-height: 100%;
  overflow: auto;
  background: #f5f5f7;
  color: #1d1d1f;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Display", "Pretendard", system-ui, sans-serif;
}

.refactor-frame {
  max-width: 1100px;
  margin: 0 auto;
  padding: 48px 24px 96px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* ── Section Base ── */
.doc-section {
  background: #ffffff;
  border-radius: 28px;
  padding: 48px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: none;
  /* Section top divider (each section except hero) */
}
.doc-section:not(.hero) {
  border-top: 3px solid rgba(0, 0, 0, 0.06);
}

/* ── Typography ── */
.eyebrow,
.section-kicker {
  display: inline-flex;
  align-items: center;
  margin: 0 0 16px;
  padding: 7px 16px;
  border-radius: 100px;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.table-title {
  margin: 0 0 20px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #aeaeb2;
}

h1, h2 {
  margin: 0;
  letter-spacing: -0.04em;
  color: #1d1d1f;
}

h1 {
  font-size: 40px;
  font-weight: 700;
  line-height: 1.15;
}

h2 {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
}

h3 {
  margin: 0;
  font-size: 17px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
}

.hero-copy,
.section-copy {
  margin: 14px 0 0;
  font-size: 16px;
  line-height: 1.8;
  color: #6e6e73;
  letter-spacing: -0.01em;
}

.hero-copy {
  font-size: 17px;
  line-height: 1.7;
}

/* ── Hero ── */
.hero {
  background: linear-gradient(180deg, #fbfbfd 0%, #ffffff 100%);
  padding: 64px 52px 52px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
}
.hero::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #5856d6 0%, #0071e3 50%, #af52de 100%);
  border-radius: 28px 28px 0 0;
}

.hero .eyebrow {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.hero h1 {
  font-size: 44px;
  font-weight: 700;
  letter-spacing: -0.05em;
  background: linear-gradient(135deg, #1d1d1f 0%, #434343 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ── Fact Grid ── */
.fact-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 36px;
}

.fact-card {
  padding: 24px;
  border-radius: 20px;
  background: rgba(88, 86, 214, 0.04);
  border: none;
}

.fact-card dt {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #aeaeb2;
}

.fact-card dd {
  margin: 10px 0 0;
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 1.6;
  letter-spacing: -0.01em;
}

/* ── Section Kicker Accents ── */
.section-overview .section-kicker {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}

.section-ocr .section-kicker {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.section-embed .section-kicker {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}

.section-vector .section-kicker {
  background: rgba(0, 122, 255, 0.1);
  color: #007aff;
}

.section-qa .section-kicker {
  background: rgba(175, 82, 222, 0.1);
  color: #af52de;
}

/* Section top colored border overrides */
.section-overview {
  border-top-color: rgba(88, 86, 214, 0.3) !important;
}

.section-ocr {
  border-top-color: rgba(0, 113, 227, 0.3) !important;
}

.section-embed {
  border-top-color: rgba(88, 86, 214, 0.3) !important;
}

.section-vector {
  border-top-color: rgba(0, 122, 255, 0.3) !important;
}

.section-qa {
  border-top-color: rgba(175, 82, 222, 0.3) !important;
}

/* ── Preview Cards ── */
.rf-preview-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-top: 32px;
}

.rf-preview-card {
  padding: 28px;
  border-radius: 20px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.06);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.rf-preview-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
}
.rf-preview-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.rf-preview-card--ocr::before {
  background: #0071e3;
}

.rf-preview-card--embed::before {
  background: #5856d6;
}

.rf-preview-card--vector::before {
  background: #007aff;
}

.rf-preview-card--qa::before {
  background: #af52de;
}

.rf-preview-kicker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 14px;
}

.rf-preview-card--ocr .rf-preview-kicker {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rf-preview-card--embed .rf-preview-kicker {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rf-preview-card--vector .rf-preview-kicker {
  background: rgba(0, 122, 255, 0.08);
  color: #007aff;
}

.rf-preview-card--qa .rf-preview-kicker {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}

.rf-preview-title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.02em;
  margin: 0 0 10px;
}

.rf-preview-change {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 100px;
  margin-bottom: 12px;
}

.rf-preview-card--ocr .rf-preview-change {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rf-preview-card--embed .rf-preview-change {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rf-preview-card--vector .rf-preview-change {
  background: rgba(0, 122, 255, 0.08);
  color: #007aff;
}

.rf-preview-card--qa .rf-preview-change {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}

.rf-preview-desc {
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.7;
  margin: 0;
  letter-spacing: -0.01em;
}

/* ── Fade Animation ── */
.pl3-fade {
  opacity: 0;
  animation: pl3FadeIn 0.6s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}

@keyframes pl3FadeIn {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* ── English Pipeline (OCR / Embed / Vector) ── */
.rf-en-pipeline {
  margin: 28px 0 12px;
  padding: 32px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
  border: none;
}
.rf-en-pipeline::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 4px 0 0 4px;
}
.rf-en-pipeline--ocr::before {
  background: #0071e3;
}
.rf-en-pipeline--embed::before {
  background: #5856d6;
}
.rf-en-pipeline--vector::before {
  background: #007aff;
}

.rf-en-pipeline-track {
  display: flex;
  align-items: flex-start;
  gap: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.rf-en-pipeline-node {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  min-width: 100px;
  text-align: center;
}

.rf-en-pipeline-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  margin-bottom: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
  border: none;
}
.rf-en-pipeline-icon svg {
  width: 26px;
  height: 26px;
}
.rf-en-pipeline-icon:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.rf-en-icon--target,
.rf-en-icon--image,
.rf-en-icon--eye,
.rf-en-icon--shield {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rf-en-pipeline--ocr .rf-en-icon--save {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}
.rf-en-pipeline--embed .rf-en-icon--save {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rf-en-icon--split,
.rf-en-icon--grid,
.rf-en-icon--cube,
.rf-en-icon--filter {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rf-en-icon--cloud,
.rf-en-icon--database,
.rf-en-icon--key,
.rf-en-icon--upload,
.rf-en-icon--refresh {
  background: rgba(0, 122, 255, 0.08);
  color: #007aff;
}

.rf-en-pipeline-label {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.02em;
  margin-bottom: 3px;
}

.rf-en-pipeline-sub {
  font-size: 12px;
  color: #aeaeb2;
  font-weight: 500;
}

.rf-en-pipeline-arrow {
  display: flex;
  align-items: center;
  padding-top: 16px;
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.12);
}
.rf-en-pipeline-arrow svg {
  width: 32px;
  height: 24px;
}

.rf-en-pipeline--ocr .rf-en-pipeline-arrow {
  color: rgba(0, 113, 227, 0.25);
}

.rf-en-pipeline--embed .rf-en-pipeline-arrow {
  color: rgba(88, 86, 214, 0.25);
}

.rf-en-pipeline--vector .rf-en-pipeline-arrow {
  color: rgba(0, 122, 255, 0.25);
}

/* ── Vertical Timeline ── */
.rf-vtl {
  margin: 24px 0;
  padding: 32px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  position: relative;
  overflow: hidden;
  border: none;
}
.rf-vtl::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-radius: 4px 0 0 4px;
}

.rf-vtl--ocr::before {
  background: #0071e3;
}

.rf-vtl--embed::before {
  background: #5856d6;
}

.rf-vtl--vector::before {
  background: #007aff;
}

.rf-vtl--qa::before {
  background: #af52de;
}

.rf-vtl-step {
  display: flex;
  align-items: stretch;
  gap: 18px;
}

.rf-vtl-marker {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  position: relative;
}

.rf-vtl-step:not(:first-child) .rf-vtl-marker::before {
  content: "";
  position: absolute;
  top: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  height: calc(50% + 8px - 18px);
}

.rf-vtl-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  z-index: 1;
  position: relative;
  border: none;
}

.rf-vtl--ocr .rf-vtl-num {
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.rf-vtl--embed .rf-vtl-num {
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
}

.rf-vtl--vector .rf-vtl-num {
  background: rgba(0, 122, 255, 0.1);
  color: #007aff;
}

.rf-vtl--qa .rf-vtl-num {
  background: rgba(175, 82, 222, 0.1);
  color: #af52de;
}

.rf-vtl-line {
  position: absolute;
  top: calc(50% + 18px);
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
}

.rf-vtl--ocr .rf-vtl-line,
.rf-vtl--ocr .rf-vtl-step:not(:first-child) .rf-vtl-marker::before {
  background: rgba(0, 113, 227, 0.15);
}

.rf-vtl--embed .rf-vtl-line,
.rf-vtl--embed .rf-vtl-step:not(:first-child) .rf-vtl-marker::before {
  background: rgba(88, 86, 214, 0.15);
}

.rf-vtl--vector .rf-vtl-line,
.rf-vtl--vector .rf-vtl-step:not(:first-child) .rf-vtl-marker::before {
  background: rgba(0, 122, 255, 0.15);
}

.rf-vtl--qa .rf-vtl-line,
.rf-vtl--qa .rf-vtl-step:not(:first-child) .rf-vtl-marker::before {
  background: rgba(175, 82, 222, 0.15);
}

.rf-vtl-card {
  flex: 1;
  padding: 18px 22px;
  border-radius: 16px;
  border: none;
  background: rgba(0, 0, 0, 0.02);
  margin-bottom: 10px;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.rf-vtl-card:hover {
  background: rgba(0, 0, 0, 0.03);
  transform: translateX(4px);
}
.rf-vtl-card p {
  font-size: 14px;
  line-height: 1.8;
  color: #6e6e73;
  margin: 0;
  letter-spacing: -0.01em;
}
.rf-vtl-card h4 {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 6px;
  letter-spacing: -0.02em;
}

/* ── Comparison Card ── */
.rf-compare-card {
  margin-top: 24px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: none;
}

.rf-compare-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 32px;
  background: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.rf-compare-title {
  font-size: 16px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0;
  letter-spacing: -0.02em;
}

.rf-compare-legend {
  display: flex;
  align-items: center;
  gap: 8px;
}

.rf-compare-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
}
.rf-compare-badge--v1 {
  background: rgba(0, 0, 0, 0.05);
  color: #6e6e73;
}
.rf-compare-badge--v2 {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rf-compare-body {
  display: flex;
  flex-direction: column;
}

.rf-compare-row {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rf-compare-row:last-child {
  border-bottom: none;
}
.rf-compare-row--alt {
  background: rgba(0, 0, 0, 0.015);
}
.rf-compare-row:hover {
  background: rgba(0, 113, 227, 0.02);
  transform: translateX(4px);
}

.rf-compare-label {
  padding: 18px 32px 10px;
  font-size: 13px;
  font-weight: 700;
  color: #1d1d1f;
  letter-spacing: -0.01em;
  position: relative;
}
.rf-compare-label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 14px;
  bottom: 6px;
  width: 3px;
  border-radius: 0 3px 3px 0;
  background: #0071e3;
}

.rf-compare-cols {
  display: grid;
  grid-template-columns: 1fr 40px 1fr;
  gap: 0;
  padding: 0 32px 18px;
  align-items: stretch;
}

.rf-compare-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aeaeb2;
  font-size: 18px;
}

.rf-compare-v1,
.rf-compare-v2 {
  padding: 16px 20px;
  border-radius: 16px;
  position: relative;
}

.rf-compare-v1 {
  background: rgba(0, 0, 0, 0.03);
}
.rf-compare-v1 p {
  font-size: 14px;
  line-height: 1.7;
  color: #6e6e73;
  margin: 0;
}

.rf-compare-v2 {
  background: rgba(0, 113, 227, 0.04);
}
.rf-compare-v2 p {
  font-size: 14px;
  line-height: 1.7;
  color: #1d1d1f;
  margin: 0;
  font-weight: 500;
}

.rf-compare-tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 8px;
}
.rf-compare-tag--v1 {
  background: rgba(0, 0, 0, 0.05);
  color: #aeaeb2;
}
.rf-compare-tag--v2 {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

/* ── Embed Transition Card ── */
.rf-embed-transition {
  margin-top: 28px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 32px;
  position: relative;
  border: none;
}
.rf-embed-transition::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #5856d6;
  border-radius: 4px 0 0 4px;
}

.rf-embed-transition-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.rf-embed-transition-icon {
  width: 22px;
  height: 22px;
  color: #5856d6;
  flex-shrink: 0;
}

.rf-embed-transition-title {
  font-size: 17px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0;
  letter-spacing: -0.02em;
}

.rf-embed-transition-copy {
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.7;
  margin: 0 0 24px;
}

.rf-embed-transition-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.rf-embed-transition-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  background: rgba(88, 86, 214, 0.04);
  border-radius: 16px;
  border: none;
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rf-embed-transition-card:hover {
  background: rgba(88, 86, 214, 0.07);
  transform: translateX(3px);
}

.rf-embed-transition-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(88, 86, 214, 0.1);
  color: #5856d6;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.rf-embed-transition-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 4px;
  letter-spacing: -0.01em;
}

.rf-embed-transition-card-desc {
  font-size: 13px;
  color: #6e6e73;
  line-height: 1.6;
  margin: 0;
}

/* ── Pipeline Labels ── */
.rf-pipeline-label {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 36px;
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.01em;
}

.rf-pipeline-badge {
  display: inline-flex;
  padding: 3px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
}
.rf-pipeline-badge--v1 {
  background: rgba(0, 0, 0, 0.05);
  color: #6e6e73;
}
.rf-pipeline-badge--v2 {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}

.rf-pipeline-tag {
  font-size: 12px;
  font-weight: 500;
  color: #aeaeb2;
  padding: 3px 10px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.03);
}

.rf-pipeline-tag--active {
  background: rgba(175, 82, 222, 0.08) !important;
  color: #af52de !important;
  font-weight: 600;
}

/* ── v1 Pipeline ── */
.rf-v1-pipeline {
  margin-top: 16px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  position: relative;
  border: none;
}
.rf-v1-pipeline::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #86868b 0%, #6e6e73 100%);
  border-radius: 4px 0 0 4px;
}

.rf-v1-stage {
  margin: 24px 32px 0;
  border-radius: 16px;
  overflow: hidden;
  border: none;
}

.rf-v1-stage--1 {
  background: rgba(0, 113, 227, 0.04);
}

.rf-v1-stage--2 {
  background: rgba(52, 199, 89, 0.04);
}

.rf-v1-stage-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 22px 12px;
  flex-wrap: wrap;
}

.rf-v1-stage-badge {
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.rf-v1-stage-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.01em;
}

.rf-v1-stage-sub {
  font-size: 12px;
  color: #aeaeb2;
  font-family: "SF Mono", "Fira Code", monospace;
}

.rf-v1-stage-flow {
  display: flex;
  align-items: flex-start;
  padding: 0 22px 20px;
  gap: 0;
}

.rf-v1-stage-item {
  display: flex;
  align-items: flex-start;
  flex: 1;
  min-width: 0;
}

.rf-v1-stage-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  min-width: 0;
}

.rf-v1-stage-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
}

.rf-v1-stage-content {
  flex: 1;
  min-width: 0;
}

.rf-v1-stage-step-head {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.rf-v1-stage-actor {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 6px;
  border-radius: 6px;
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rf-v1-stage-step-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0;
}

.rf-v1-stage-step-desc {
  font-size: 12px;
  color: #6e6e73;
  line-height: 1.5;
  margin: 0;
}

.rf-v1-stage-connector {
  display: flex;
  align-items: center;
  width: 28px;
  flex-shrink: 0;
  padding-top: 8px;
  color: rgba(0, 0, 0, 0.1);
}
.rf-v1-stage-connector svg {
  width: 24px;
  height: 24px;
}

.rf-v1-stage-bridge {
  display: flex;
  justify-content: center;
  padding: 0;
}
.rf-v1-stage-bridge svg {
  width: 24px;
  height: 28px;
}

.rf-v1-loop {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 32px;
}

.rf-v1-loop-line {
  flex: 1;
  height: 1px;
  background: rgba(0, 0, 0, 0.06);
}

.rf-v1-loop-label {
  font-size: 12px;
  font-weight: 600;
  color: #6e6e73;
  white-space: nowrap;
  padding: 4px 14px;
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.03);
}

.rf-v1-output {
  margin: 0 32px 24px;
  padding: 20px 22px;
  border-radius: 16px;
  background: rgba(0, 0, 0, 0.02);
  border: none;
}

.rf-v1-output-header {
  font-size: 13px;
  font-weight: 700;
  color: #6e6e73;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin-bottom: 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.rf-v1-output-steps {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
}

.rf-v1-output-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.rf-v1-output-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.04);
  color: #6e6e73;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.rf-v1-output-label {
  font-size: 13px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 1.3;
}

.rf-v1-output-desc {
  font-size: 12px;
  color: #aeaeb2;
  line-height: 1.4;
}

/* ── QA Transition ── */
.rf-qa-transition {
  margin-top: 32px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 32px;
  position: relative;
  border: none;
}
.rf-qa-transition::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #ff3b30;
  border-radius: 4px 0 0 4px;
}

.rf-qa-transition-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.rf-qa-transition-icon {
  width: 22px;
  height: 22px;
  color: #ff3b30;
  flex-shrink: 0;
}

.rf-qa-transition-title {
  font-size: 17px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0;
  letter-spacing: -0.02em;
}

.rf-qa-transition-copy {
  font-size: 14px;
  color: #6e6e73;
  line-height: 1.7;
  margin: 0 0 24px;
}

.rf-qa-transition-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.rf-qa-transition-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 18px 20px;
  background: rgba(255, 59, 48, 0.04);
  border-radius: 16px;
  border: none;
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rf-qa-transition-card:hover {
  background: rgba(255, 59, 48, 0.06);
  transform: translateX(3px);
}

.rf-qa-transition-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 59, 48, 0.08);
  color: #ff3b30;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.rf-qa-transition-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 4px;
}

.rf-qa-transition-card-desc {
  font-size: 13px;
  color: #6e6e73;
  line-height: 1.6;
  margin: 0;
}

/* ── QA Pipeline v2 ── */
.rf-qa-pipeline {
  margin-top: 24px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  position: relative;
  border: none;
}
.rf-qa-pipeline::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: linear-gradient(180deg, #af52de 0%, #9b29d4 100%);
  border-radius: 4px 0 0 4px;
}

.rf-qa-phase {
  padding: 24px 32px 20px;
}

.rf-qa-phase-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.rf-qa-phase-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 12px;
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
  font-size: 13px;
  font-weight: 700;
}

.rf-qa-phase-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
}

.rf-qa-fork,
.rf-qa-merge {
  display: flex;
  justify-content: center;
  padding: 0 32px;
}

.rf-qa-fork-svg,
.rf-qa-merge-svg {
  width: 100%;
  max-width: 600px;
  height: 60px;
}

.rf-qa-tracks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  padding: 0 32px 12px;
}

.rf-qa-track {
  border-radius: 16px;
  padding: 24px;
  background: rgba(0, 0, 0, 0.02);
  position: relative;
  border: none;
}
.rf-qa-track::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  border-radius: 16px 16px 0 0;
}

.rf-qa-track--single::before {
  background: #0071e3;
}

.rf-qa-track--multi::before {
  background: #5856d6;
}

.rf-qa-track-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.rf-qa-mode-badge {
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 700;
}
.rf-qa-mode-badge--single {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}
.rf-qa-mode-badge--multi {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rf-qa-track-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d1d1f;
  letter-spacing: -0.01em;
}

.rf-qa-track-note {
  font-size: 13px;
  color: #aeaeb2;
  margin: 0 0 16px;
}

.rf-qa-track-steps {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rf-qa-track-step {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.rf-qa-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}
.rf-qa-step-num--single {
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}
.rf-qa-step-num--multi {
  background: rgba(88, 86, 214, 0.08);
  color: #5856d6;
}

.rf-qa-step-label {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  line-height: 1.4;
}

.rf-qa-step-desc {
  font-size: 13px;
  color: #6e6e73;
  line-height: 1.4;
}

/* ── V2 Advantages ── */
.rf-qa-adv {
  margin-top: 28px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  padding: 32px;
  position: relative;
  border: none;
}
.rf-qa-adv::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #0071e3;
  border-radius: 4px 0 0 4px;
}

.rf-qa-adv-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
}

.rf-qa-adv-title {
  font-size: 17px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0;
  letter-spacing: -0.02em;
}

.rf-qa-adv-badge {
  display: inline-flex;
  padding: 4px 12px;
  border-radius: 100px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(0, 113, 227, 0.08);
  color: #0071e3;
}

.rf-qa-adv-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;
}

.rf-qa-adv-card {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 18px 20px;
  background: rgba(0, 113, 227, 0.03);
  border-radius: 16px;
  border: none;
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rf-qa-adv-card:hover {
  background: rgba(0, 113, 227, 0.06);
  transform: translateX(3px);
}

.rf-qa-adv-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(0, 113, 227, 0.1);
  color: #0071e3;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.rf-qa-adv-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 4px;
}

.rf-qa-adv-card-desc {
  font-size: 13px;
  color: #6e6e73;
  line-height: 1.6;
  margin: 0;
}

/* ── Key Diff Cards ── */
.rf-diff-cards {
  margin-top: 28px;
}

.rf-diff-cards-title {
  font-size: 17px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0 0 16px;
  letter-spacing: -0.02em;
}

.rf-diff-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.rf-diff-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: none;
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rf-diff-card:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.rf-diff-label {
  font-size: 13px;
  font-weight: 700;
  color: #1d1d1f;
  margin-bottom: 12px;
}

.rf-diff-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
}
.rf-diff-row:last-child {
  margin-bottom: 0;
}

.rf-diff-ver {
  display: inline-flex;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 2px;
}
.rf-diff-ver--v1 {
  background: rgba(0, 0, 0, 0.05);
  color: #6e6e73;
}
.rf-diff-ver--v2 {
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
}

.rf-diff-text {
  font-size: 13px;
  color: #6e6e73;
  line-height: 1.5;
}

/* ── Finetune Grid ── */
.rf-finetune-grid {
  margin-top: 24px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  border: none;
}

.rf-finetune-header {
  padding: 22px 32px;
  background: rgba(0, 0, 0, 0.02);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.rf-finetune-title {
  font-size: 16px;
  font-weight: 700;
  color: #1d1d1f;
  margin: 0;
  letter-spacing: -0.02em;
}

.rf-finetune-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.rf-finetune-card {
  padding: 22px 28px;
  border-right: 1px solid rgba(0, 0, 0, 0.06);
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  transition: background 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), transform 0.2s ease;
}
.rf-finetune-card:hover {
  background: rgba(175, 82, 222, 0.02);
  transform: translateX(3px);
}
.rf-finetune-card:nth-child(2n) {
  border-right: none;
}
.rf-finetune-card:nth-last-child(-n+2) {
  border-bottom: none;
}

.rf-finetune-label {
  font-size: 12px;
  font-weight: 600;
  color: #aeaeb2;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.rf-finetune-keyword {
  display: inline-flex;
  padding: 3px 10px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 700;
  background: rgba(175, 82, 222, 0.08);
  color: #af52de;
  margin-bottom: 8px;
}

.rf-finetune-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #6e6e73;
  margin: 0;
  letter-spacing: -0.01em;
}

/* ── Summary / Card Grid / Table (unused but safe) ── */
.summary-table {
  margin-top: 28px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.summary-row {
  display: grid;
  grid-template-columns: 180px 1fr;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

.summary-key {
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
}

.summary-value {
  font-size: 15px;
  line-height: 1.75;
  color: #6e6e73;
}

.card-grid {
  display: grid;
  gap: 14px;
  margin-top: 24px;
  grid-template-columns: repeat(2, 1fr);
}

.card-grid.three {
  grid-template-columns: repeat(3, 1fr);
}

.info-card {
  padding: 28px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  border: none;
  transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1), box-shadow 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
}
.info-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}
.info-card h3 {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.02em;
}
.info-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.7;
  color: #6e6e73;
}

/* ── Scroll to Top ── */
.scroll-top-btn {
  position: fixed;
  bottom: 40px;
  right: max(24px, (100vw - 1100px) / 2 - 72px);
  z-index: 100;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.06);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6e6e73;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.2s ease, color 0.2s ease, opacity 0.3s ease;
  animation: scrollBtnIn 0.3s ease forwards;
}
.scroll-top-btn svg {
  width: 20px;
  height: 20px;
}
.scroll-top-btn:hover {
  transform: translateY(-3px) scale(1.08);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  color: #0071e3;
}
.scroll-top-btn:active {
  transform: translateY(0) scale(0.95);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

@keyframes scrollBtnIn {
  from {
    opacity: 0;
    transform: translateY(16px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/* ── Responsive ── */
@media (max-width: 768px) {
  .refactor-frame {
    padding: 24px 16px 48px;
    gap: 20px;
  }
  .doc-section {
    padding: 28px 20px;
    border-radius: 20px;
  }
  .hero {
    padding: 36px 24px;
  }
  .hero h1, h1 {
    font-size: 28px;
  }
  h2 {
    font-size: 22px;
  }
  .fact-grid, .rf-preview-grid, .rf-diff-grid, .rf-qa-tracks, .rf-qa-adv-grid,
  .rf-embed-transition-grid, .rf-qa-transition-grid, .rf-finetune-body,
  .card-grid, .card-grid.three {
    grid-template-columns: 1fr;
  }
  .rf-v1-stage-flow, .rf-v1-output-steps {
    flex-direction: column;
    grid-template-columns: 1fr;
  }
  .rf-v1-stage-connector {
    transform: rotate(90deg);
    width: auto;
    justify-content: center;
    padding: 0;
  }
  .rf-compare-cols {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .rf-compare-arrow {
    display: none;
  }
  .rf-en-pipeline {
    padding: 20px;
  }
  .rf-en-pipeline-icon {
    width: 44px;
    height: 44px;
  }
  .rf-en-pipeline-icon svg {
    width: 20px;
    height: 20px;
  }
  .rf-finetune-card {
    border-right: none;
  }
}`],
})
export class PageRefactoringComponent implements OnInit {
    public showScrollTop = false;
    private scrollEl: any;
    public topFacts = [
        ['문서 목적', '초기 설계와 현재 운영 구현의 구조적 차이를 정리'],
        ['비교 축', 'OCR / Embedding / Vector DB / QA Dataset']
    ];

    public sectionPreviews = [
        {
            kicker: '02',
            title: 'OCR',
            accent: 'ocr',
            change: '외부 OCR → Vision LLM + 4-scope 실행',
            desc: 'pypdfium2 200DPI 래스터화 후 Gemini(PIL 직접)/GPT-4.1(base64 JPEG, detail:high) Vision 호출. file/selected/folder/collection scope와 파일 단위 에러 격리'
        },
        {
            kicker: '03',
            title: 'Embedding',
            accent: 'embed',
            change: '5단계 필터링 → 3단계 포맷 분기형',
            desc: '3가지 OCR 포맷 자동 분기 → 500자/50자 overlap 슬라이딩 윈도우 → 100개 배치 API 호출. 전처리·품질 필터 제거'
        },
        {
            kicker: '04',
            title: 'Vector DB',
            accent: 'vector',
            change: 'pymilvus → REST v2 + 6필드 스키마',
            desc: 'HTTP REST v2 기반 7개 엔드포인트 사용. 50개 배치 upsert, force 재삽입, sync_vector_status 복구까지 운영 안정성 확보'
        },
        {
            kicker: '05',
            title: 'QA Dataset',
            accent: 'qa',
            change: '쿼리 중심 → 파일 중심',
            desc: '2-Stage RAG에서 파일 선택 기반 파이프라인으로 전환, 통합 생성·출처 추적·장애 복구 강화'
        }
    ];

    // ─── English Pipeline Steps ───
    public ocrPipelineEn = [
        { label: 'Scope', sub: '4 modes', icon: 'target' },
        { label: 'Rasterize', sub: '200 DPI', icon: 'image' },
        { label: 'Vision LLM', sub: 'Gemini / GPT', icon: 'eye' },
        { label: 'Save', sub: '_ocr.json', icon: 'save' },
        { label: 'Isolate', sub: 'Error fence', icon: 'shield' }
    ];

    public embPipelineEn = [
        { label: 'Parse', sub: '3 formats', icon: 'split' },
        { label: 'Chunk', sub: '500 / 50', icon: 'grid' },
        { label: 'Vectorize', sub: '1536-dim', icon: 'cube' },
        { label: 'Save', sub: 'JSON pair', icon: 'save' },
        { label: 'Scope', sub: 'Skip logic', icon: 'filter' }
    ];

    public vecPipelineEn = [
        { label: 'REST API', sub: 'HTTP v2', icon: 'cloud' },
        { label: 'Schema', sub: '6 fields', icon: 'database' },
        { label: 'ID Gen', sub: 'MD5 hash', icon: 'key' },
        { label: 'Upsert', sub: '50 batch', icon: 'upload' },
        { label: 'Sync', sub: 'Recovery', icon: 'refresh' }
    ];

    public ocrFlow = [
        '4가지 scope(file/selected/folder/collection)로 대상 파일 수집, _ocr.json 존재 시 자동 skip',
        'pypdfium2로 200 DPI(scale=200/72≈2.78x) 래스터화, 전체 페이지를 PIL Image 리스트로 변환',
        'Gemini 2.5 Flash(PIL 직접 전달) 또는 GPT-4.1(base64 JPEG quality=85, detail:high, max_tokens=16384) 호출',
        'pages 배열에 page 번호, text, text_length 저장 → {base_name}_ocr.json. 별도 status 파일 없음',
        '파일 단위 try/except 격리. SSE로 page_done/file_done/file_error 이벤트 송신'
    ];

    public embeddingFlow = [
        '_ocr.json을 읽어 3가지 포맷(list형/dict+pages/dict fallback) 자동 분기. URL 필드 제외',
        '500자 고정 슬라이딩 윈도우(overlap 50자, 실질 이동 450자). 각 청크에 chunk_id/page/start/end 메타',
        'OpenAI text-embedding-3-small에 100개 배치 호출. 응답 순서 보장으로 인덱스 매핑',
        '_embedding.json(file, cwd, chunk_size, overlap, chunks)과 _embedding.status.json 동시 저장',
        'file/selected/folder/collection scope 지원. 완료(already_done) 또는 빈 텍스트(no_text) 시 자동 skip'
    ];

    public vectorFlow = [
        'Milvus REST v2 엔드포인트(http)로 호출. pymilvus SDK 미사용. has/create/upsert/query/search/list/get_stats 7개 API',
        'has API로 컬렉션 확인 → 없으면 6필드(id, user_id, file_name, page_number, text, vector) + L2 인덱스 생성',
        'ID는 {coll_id}_{md5(file)[:12]}_{idx}. 64바이트 초과 시 MD5 재해싱 → upsert 멱등성 보장',
        '50개 배치 upsert. text≤65535자, file_name≤512자, vector=1536차원 검증 후 삽입',
        'force 모드 + 빈 컬렉션 감지 → ignore_status 자동 결정. sync_vector_status()로 status 파일 복구'
    ];

    public ocrDiffRows = [
        ['주요 엔진', 'pdfplumber / pdf2image / Gemini 2.5 Flash / GPT-4.1 Vision', 'pypdfium2(200DPI, scale=200/72) + Gemini 2.5 Flash(PIL 직접) / GPT-4.1(base64 JPEG, detail:high, max_tokens=16384)'],
        ['실행 범위', '단일 흐름 중심', 'file/selected/folder/collection 4가지 scope. selected는 폴더 os.walk 재귀 확장'],
        ['클라이언트 관리', '호출마다 클라이언트 생성', 'Lazy 초기화 — 배치 내 1회만 OpenAI/Gemini 클라이언트 생성, 요청 단위 인스턴스'],
        ['결과 판단', '_ocr.status.json 진행률 추적', '_ocr.json 실파일 존재를 완료 기준으로 사용. 별도 status 파일 없음'],
        ['에러 처리', '기본 예외 처리', '파일 단위 try/except 격리. file_error 이벤트 후 다음 파일 계속 진행']
    ];

    public embWhySimplified = [
        { title: 'OCR 품질 변화', desc: 'pdfplumber 기반 텍스트 추출에서 Vision LLM 직접 페이지 판독으로 전환. normalize_ocr_text·is_bad_chunk·SHA-1 중복 제거의 다단계 필터링 필요성 소멸' },
        { title: '파일 단위 컨텍스트 전환', desc: 'QA 생성이 파일 선택 후 전체 컨텍스트 활용 구조로 전환. 개별 청크 정밀도 의존도가 낮아져 청크 품질 필터 실익 감소' },
        { title: '3가지 OCR 포맷 자동 분기', desc: 'list형(레코드 배열), dict+pages(PDF OCR), dict fallback(단일 레코드) — 다양한 입력 소스를 단일 파이프라인으로 통합 처리' },
        { title: '운영 유연성 우선', desc: '전처리·필터링 로직 대신 file/selected/folder/collection 4가지 scope 지원으로 대량 데이터 재처리와 부분 실행 용이' }
    ];

    public embeddingDiffRows = [
        ['청킹 파라미터', '700자 chunk_size + 120자 overlap (step=580자), 꼬리 120자 미만 시 이전 청크에 병합', '500자 chunk_size + 50자 overlap (step=450자). 꼬리 병합 없이 마지막 청크는 원본 길이 그대로'],
        ['입력 포맷 분기', '단일 텍스트 입력', '3가지 OCR 포맷 자동 분기: list형(레코드 배열), dict+pages(PDF OCR), dict fallback(단일 레코드)'],
        ['전처리', 'normalize_ocr_text() — \\r 제거, 연속 공백 합치기, 빈 줄 3→2줄 축소, 기호만 5자 이상 줄 삭제', 'URL 필드(source_url, images, url, link) 제외 외 별도 전처리 없음'],
        ['품질 필터', 'is_bad_chunk() — 반복 줄 ≥55%, 고유 문자 ≤12%, n-gram(n=12) ≥3.5%, 길이<40 AND 유효문자<20 스킵', '별도 품질 필터 없음 — Vision LLM OCR 품질 향상으로 불필요'],
        ['중복 제거', 'chunk_fingerprint() — SHA-1 해시 기반 seen_fps 집합으로 동일 텍스트 청크 중복 임베딩 방지', '별도 중복 제거 없이 전량 임베딩'],
        ['임베딩 모델', 'OpenAI text-embedding-3-small', 'OpenAI text-embedding-3-small (동일). 100개 배치 호출, 응답 순서 보장으로 인덱스 매핑'],
        ['파이프라인', '5단계: 전처리 → 품질 검증 → 슬라이딩 윈도우 → 청크 품질+중복 제거 → 벡터화', '3단계: OCR 포맷 분기·텍스트 추출 → 슬라이딩 윈도우(메타 포함) → 벡터화'],
        ['실행 범위', '단일 데이터셋 흐름 중심', 'file/selected/folder/collection scope 지원. 완료된 파일 자동 skip'],
        ['산출물', '{filename}_embedding.json (청크 텍스트 + 벡터 + 페이지/위치 메타데이터)', '_embedding.json(file, cwd, chunk_size, overlap, chunks) + _embedding.status.json(status, model, chunks수, created_at)']
    ];

    public vectorDiffRows = [
        ['Milvus 연동 방식', 'pymilvus 직접 연결 (connections.connect → Collection)', 'requests 기반 REST v2 (has/create/upsert/query/search/list/get_stats 7개 엔드포인트)'],
        ['스키마', '개념 설명 수준', 'id(VarChar 64), user_id(64), file_name(512), page_number(Int64), text(65535), vector(FloatVector 1536) + L2 인덱스'],
        ['ID 생성', '자동 할당', '{collection_id}_{md5(base_name)[:12]}_{chunk_idx}. 64바이트 초과 시 MD5 재해싱 → upsert 멱등성'],
        ['적재 단위', 'collection.insert 개념 설명', '50개 배치 entities/upsert. text≤65535, file_name≤512, vector=1536차원 검증'],
        ['재삽입 로직', '없음', 'force 파라미터 + Milvus 빈 컬렉션 감지 → ignore_status 자동 결정'],
        ['상태 복구', '없음', 'sync_vector_status() — Milvus 실 데이터 기준 _vector.status.json 자동 복구'],
        ['운영 지표', '벡터 DB 적재 여부 중심', '_vector.status.json 파일 수(문서 완료) + get_stats rowCount(청크 row) 분리 집계']
    ];

    public qaDiffRows = [
        ['생성 전략', '2-Stage RAG: 검색 쿼리를 먼저 만들고, 1차 검색→질문 생성→2차 검색→답변 생성의 쿼리 중심 파이프라인', '파일 선택 기반: 데이터셋에서 파일을 먼저 선택(single/multi)한 뒤 해당 파일 컨텍스트로 Q+A를 함께 생성'],
        ['파일 선택 방식', '파일 선택 개념 없음 — 쿼리가 직접 Top-K passage를 검색', 'single 모드(1개 파일)와 multi 모드(3개 파일) 중 선택, semantic search + 라벨 fallback으로 파일 랭킹'],
        ['Milvus 연동', 'pymilvus 직접 연결 (connections.connect → Collection → coll.search)', 'Milvus REST v2 API (HTTP requests 기반, 상태 파일 관리 포함)'],
        ['출처 추적', 'qa_topk 테이블에 level·distance·context 저장', 'source_chunks 필드로 청크 단위 추적 + PDF 경로 복원 + 중복 제거 + 출처 보강'],
        ['안정성', 'SSE 스트리밍으로 실시간 진행만 표시', 'heartbeat + partial save로 중간 저장, 네트워크 중단 시 저장 지점부터 복구'],
        ['검수→내보내기', 'qa_review(승인/반려) → CSV 다운로드', '검수(승인/반려) → 마감(finalize) → CSV Export (마감 단계가 추가됨)']
    ];

    public finetuneDetail = [
        ['기본 모드', 'single', '하나의 문서 안에서 문맥이 일관된 QA를 만드는 방식'],
        ['확장 모드', 'multi', '서로 다른 문서를 최대 3개까지 조합해서 융합형 QA를 생성하는 방식'],
        ['파일 선택', 'semantic + fallback', '먼저 의미 검색으로 관련 문서를 찾고, 검색이 안 되면 라벨 유사도 점수로 대체 선택'],
        ['출처 저장', 'source_chunks', 'QA가 어떤 문서의 어떤 부분에서 나왔는지를 중복 없이 기록'],
        ['안정성', 'heartbeat + partial save', 'AI가 답변을 만드는 도중에도 주기적으로 저장하고, 연결이 끊기면 저장된 부분부터 다시 이어서 복구']
    ];

    // v1 2-Stage RAG 파이프라인 — Stage 구조
    public v1Stage1 = [
        { step: '1차 Retrieval', desc: 'query를 임베딩 변환 → pymilvus coll.search() → Top-K passage 확보', actor: '시스템', icon: 'search' },
        { step: '질문(Q) 생성', desc: '1차 검색 결과의 passage를 컨텍스트로 질문만 생성', actor: 'LLM', icon: 'question' },
        { step: '중복 제거', desc: '세션 내 중복 + DB 기존 질문과 비교하여 중복 폐기 (최대 5회 재시도)', actor: '시스템', icon: 'filter' }
    ];

    public v1Stage2 = [
        { step: '2차 Retrieval', desc: '확정된 질문으로 다시 Milvus Top-K 재검색 → 답변 근거 문맥 수집', actor: '시스템', icon: 'search' },
        { step: '답변(A) 생성', desc: 'SHORT(60%) / MEDIUM(30%) / COT(10%) 확률 스타일로 답변 생성', actor: 'LLM', icon: 'answer' },
        { step: '근거 추출', desc: 'referenced_sentences — 원문 그대로의 출처 문장 추출', actor: 'LLM', icon: 'cite' }
    ];

    public v1Output = [
        { step: 'DB 저장', desc: 'qa_dataset(QA 본문) + qa_topk(Top-K 근거 문맥) 동시 저장' },
        { step: 'SSE 스트리밍', desc: '생성 진행률을 실시간 전송 (log + finish 이벤트)' },
        { step: '그룹 배정', desc: 'qa_group에 검수자 배정 (assigned_user_ids)' },
        { step: '검수', desc: '승인(1) / 반려(-1) / 대기(0) → qa_review 저장' },
        { step: 'CSV 다운로드', desc: '승인된 QA만 필터링해 Fine-tuning용 CSV 내보내기' }
    ];

    // v2 파이프라인
    public qaCommonSetup = [
        { step: '데이터셋·컬렉션 연결', desc: '큐레이션 대상 데이터셋과 벡터 DB 컬렉션을 명시적으로 바인딩' },
        { step: '주라벨 / 보조라벨 선택', desc: '생성할 QA의 도메인 범위를 라벨 트리로 사전 정의' },
        { step: 'source_mode 결정', desc: 'single(단일 파일) 또는 multi(다중 파일) 모드를 선택' }
    ];

    public qaTrackSingle = [
        { step: '컬렉션 후보 청크 조회', desc: '연결된 컬렉션에서 query 기반 청크 검색' },
        { step: '파일 단위 그룹핑', desc: '동일 파일의 청크를 하나의 그룹으로 묶기' },
        { step: '상위 1개 파일 선택', desc: '프롬프트 기준 가장 관련도 높은 파일 선택' },
        { step: '선택 파일 재조회', desc: '해당 파일의 모든 청크를 다시 불러와 컨텍스트 재구성' }
    ];

    public qaTrackMulti = [
        { step: '후보 청크 분산 수집', desc: '파일 편향 없이 다양한 청크를 폭넓게 수집' },
        { step: 'semantic search 랭킹', desc: 'OpenAI embedding + Milvus로 파일 랭킹 (실패 시 라벨 fallback)' },
        { step: '상위 3개 파일 선택', desc: '가장 관련성 높은 3개 파일을 조합' },
        { step: '중복 제거 + 출처 보강', desc: '최종 컨텍스트에서 중복 출처 제거 및 부족 파일 보강' }
    ];

    public qaCommonExec = [
        { step: 'LLM QA 생성', desc: '선택 파일 컨텍스트에서 Q+A를 동시에 생성, heartbeat로 보호' },
        { step: 'source_chunks 보정·저장', desc: '청크 단위 출처 추적 + PDF 경로 복원 + 중복 제거' },
        { step: '검수 (승인 / 반려)', desc: '검수자가 QA 품질을 확인하고 승인/반려 판정' },
        { step: '마감 · CSV Export', desc: '확정 후 마감 → 승인 QA만 Fine-tuning용 CSV로 내보내기' }
    ];

    // 핵심 차이점 요약 카드
    public qaDiffPoints = [
        {
            label: '생성 전략',
            v1: '쿼리 중심 — LLM이 검색 쿼리를 먼저 설계하고 passage를 직접 사용',
            v2: '파일 중심 — 파일을 먼저 선택한 뒤 해당 파일의 전체 컨텍스트로 생성'
        },
        {
            label: 'Retrieval',
            v1: '2-Stage — 질문용 1차 검색 + 답변용 2차 검색 (pymilvus)',
            v2: '1-Stage — 파일 선택에만 검색 사용, QA 생성은 선택된 파일 컨텍스트 (REST v2)'
        },
        {
            label: 'Q/A 생성',
            v1: '분리 생성 — 질문만 먼저 만들고 답변은 별도 프롬프트로 생성',
            v2: '통합 생성 — 선택된 파일 컨텍스트에서 Q+A를 함께 생성'
        },
        {
            label: '출처 추적',
            v1: 'qa_topk — Top-K 근거 문맥의 distance·context만 저장',
            v2: 'source_chunks — 청크 단위 추적 + PDF 경로 복원 + 중복 제거'
        },
        {
            label: '장애 복구',
            v1: '없음 — SSE 연결 끊기면 진행 유실',
            v2: 'heartbeat + partial save — 중단 시 저장 지점부터 복구'
        }
    ];

    // v1 → v2 전환 사유
    public v2WhyChanged = [
        { title: '쿼리 품질 병목', desc: '기존 구현은 LLM이 설계한 검색 쿼리로 passage를 가져오는 방식으로, 한의학 전문 용어 도메인에서 쿼리 품질이 곧 QA 품질의 상한' },
        { title: '2-Stage 비효율', desc: 'Q와 A를 별도 프롬프트로 분리 생성 시 LLM 호출 2배 증가, 문맥 불일치 빈번' },
        { title: '출처 역추적 불가', desc: 'qa_topk는 distance와 context만 저장하여 실제 문서·페이지 단위 역추적 불가' },
        { title: '중단 시 전량 유실', desc: 'SSE 연결 단절 시 진행 중 QA 전량 유실로 대량 생성 작업 안정성 부족' }
    ];

    // v2 개선점
    public v2Advantages = [
        { title: '파일 중심 접근', desc: '파일을 먼저 선택하고 전체 컨텍스트를 활용 — 쿼리 품질에 의존하지 않는 안정적 생성' },
        { title: 'Q+A 통합 생성', desc: '동일 문맥에서 Q와 A를 함께 생성하여 호출 횟수 절반으로 절감, 일관성 향상' },
        { title: '청크 단위 출처', desc: 'source_chunks로 어떤 문서의 어떤 청크에서 나왔는지 정확히 추적, PDF 경로 복원' },
        { title: 'single/multi 분기', desc: '단일 문서 QA와 다중 문서 융합 QA를 목적에 맞게 전략적으로 선택 가능' },
        { title: 'heartbeat 복구', desc: '생성 중 주기적 중간 저장, 연결 단절 시 저장 지점부터 자동 복구' },
        { title: '마감 단계 추가', desc: '검수 후 마감(finalize)을 거쳐야 내보내기 가능 — 미검수 QA의 학습 데이터 유입 차단' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public async onScroll(event: any) {
        this.scrollEl = event.target;
        const show = event.target.scrollTop > 400;
        if (show !== this.showScrollTop) {
            this.showScrollTop = show;
            await this.service.render();
        }
    }

    public scrollToTop() {
        if (this.scrollEl) {
            this.scrollEl.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}

export default PageRefactoringComponent;